export const message = (message) => {
    return {
        type: 'MESSAGE',
        payload: message
    }
}